import { connect } from "react-redux";
import get from "lodash/get";

import { getCars as onGetCars } from "../../actions/carsActions";

import {
  handleConnectLastState as onConnectLastState,
  handleStartConnection as onStartConnection,
  handleAddUserToGroup as onAddUserToGroup,
  handleStopConnect as onStopConnect,
  handleRecieveUnitsLastState as onHandleRecieveUnitsLastState,
  handleStopRecieveUnitsLastState as onHandleStopRecieveUnitsLastState,
} from "../../actions/signalRActions";

import { createDriverUnit as onCreateDriverUnit, deleteDriverUnit as onDeleteDriverUnit } from "../../actions/driversAction";

const mapStateToProps = (state) => ({
  dataRecieveUnitsLastStateSR: state.units.dataRecieveUnitsLastState,
  recieveUnitsLastStateSR: get(state, ["units", "recieveUnitsLastState"], null),
  driverAddUnitDataState: state.units.driverAddUnitDataState,
  driverDeleteUnitDataState: state.units.driverDeleteUnitDataState,
  error: get(state, ["units", "error"], null),
  dataStateUnits: state.units.dataState,
  listUnits: get(state, ["units", "units"], []),
  totalUnits: get(state, ["units", "total"], 0),
  filterCountUnits: get(state, ["units", "filterCount"], 0),
  isBookmarkCountUnits: get(state, ["units", "isBookmarkCount"], 0),
});

const mapDispatchToProps = {
  onGetCars,
  onConnectLastState,
  onStartConnection,
  onAddUserToGroup,
  onStopConnect,
  onHandleRecieveUnitsLastState,
  onHandleStopRecieveUnitsLastState,
  onCreateDriverUnit,
  onDeleteDriverUnit,
};

const withCars = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withCars };
